const getPresenceStatus = (participant, connected) => {
  const connectedInClass = connected.filter(connectedStudent => connectedStudent.userId === participant._id);
  return !!connectedInClass.length;
};

export const getUpdatedParticipantsPresenceWithAPI = (participants, connected) =>
  participants.map(participant => ({
    ...participant,
    connected: getPresenceStatus(participant, connected)
  }));

export const getUpdatedParticipantsPresence = (participants, participantConnected) =>
  participants &&
  participants.map(participant =>
    participant._id === participantConnected.userId
      ? { ...participant, connected: participantConnected.connectionStatus }
      : participant
  );
